/* eslint-disable no-underscore-dangle */
/* eslint-disable no-underscore-dangle */
const AudioManagerBase = require('AudioManagerBase');
const CC_AUDIO_DEBUG = false && CC_DEBUG;


// TODO create separate channels for music and sfx

cc.Class({
    extends: AudioManagerBase,

    statics: {
        /**
         * static function to inject audio downloader handlers.
         * It is so
         */
        overrideCocosDownloader() {
            if (!CC_EDITOR && Howler) {
                function downloadAudioHowler(item, opts, callback) {
                    const param = {
                        src: [item],
                        preload: true,
                        onload: () => {

                            // pass the fake empty buffer to cocos.
                            // eslint-disable-next-line no-underscore-dangle
                            callback(null, item);
                        },
                        onloaderror: (id, msg) => {
                            callback(`howler load error - ${item}`, null);
                        }
                    };

                    // eslint-disable-next-line no-new
                    new Howl(param);
                }

                // TODO move up to audiomanager base
                const audioTypes = [
                    // types supported by COCOS
                    '.mp3',
                    '.ogg',
                    '.wav',
                    '.m4a'

                    // supported by Howler
                    // TODO if needed
                    // "mpeg", "opus",  "oga",  "aac", "caf", mp4", "weba", "webm", "dolby", "flac"
                ];

                audioTypes.forEach((type) => {
                    cc.assetManager.downloader.register(type, downloadAudioHowler);
                });
            }
        },

        injectHowlerOverrides() {
            if (CC_EDITOR) {
                return;
            }

            if (typeof Howl === 'undefined' || Howl === null) {
                throw new Error('HOWLER is null');
            }

            let _compressorEnabled = false;

            function havePendingSidechainedSounds() {
                const ret = Howler._howls.find(howl => {
                    const found = howl._sounds.find( s => s._sidechain);
                    return !!found;
                });

                console.log('compressor  havePendingSidechainedSounds: ' + !!ret)

                return !!ret;
            }

            function connectCompressor() {
                if (_compressorEnabled) return;

                _compressorEnabled = true;

                if (useCompressor()) {
                    Howler.normalGain.disconnect();
                    Howler.normalGain.connect(Howler.compressor);
                } else {
                    const { gain, attack } = Howler.sidechainSettings;

                    Howler.normalGain.gain.cancelScheduledValues(Howler.ctx.currentTime);
                    Howler.normalGain.gain.linearRampToValueAtTime(gain, Howler.ctx.currentTime + (attack));
                }

                cc.log('compressor connect');
            }

            function disconnectCompressor() {
                if (!_compressorEnabled || havePendingSidechainedSounds()) {
                    return;
                }

                _compressorEnabled = false;

                if (useCompressor()) {
                    Howler.normalGain.disconnect();
                    Howler.normalGain.connect(Howler.masterGain);
                } else {
                    const { gain, release } = Howler.sidechainSettings;

                    Howler.normalGain.gain.cancelScheduledValues(Howler.ctx.currentTime);
                    Howler.normalGain.gain.linearRampToValueAtTime(1.0, Howler.ctx.currentTime + (release));
                }

                cc.log('compressor disconnect');
            }

            // tuna.js
            function dbToWAVolume(db) {
                return Math.max(0, Math.round(100 * Math.pow(2, db / 6)) / 100);
            }

            function updateCompressorMakeUpGain(value) {
                Howler.makeUpGain.gain.value = dbToWAVolume(value || 0);
            }

            function supportSideChain() {
                return Howler.usingWebAudio && Howler.ctx.createDynamicsCompressor;
            }

            function useCompressor() {
                return false;
            }

            function updateCompressorSettings(settings) {
                if (useCompressor()) {
                    const {
                        threshold,
                        knee,
                        ratio,
                        attack,
                        release,
                        makeup,
                        autoMakeup
                    } = settings;

                    Howler.compressor.threshold.value = threshold;
                    Howler.compressor.knee.value = knee;
                    Howler.compressor.ratio.value = ratio;
                    Howler.compressor.attack.value = attack;
                    Howler.compressor.release.value = release;

                    Howler.updateCompressorMakeUpGain(autoMakeup ? computeMakeupGainForCompressor(Howler.compressor) : makeup);
                } else {
                    Howler.sidechainSettings = Object.assign(Howler.sidechainSettings, settings);
                }
            }


            function computeMakeupGainForCompressor(c) {
                var magicCoefficient = 4; // raise me if the output is too hot
                return -(c.threshold.value - c.threshold.value / c.ratio.value) / magicCoefficient;
            }

            function connectAnalyzer() {

                Howler.masterGain.disconnect();
                Howler.masterGain.connect(Howler.analyser);
            }

            function disconnectAnalyzer() {
                Howler.masterGain.disconnect();
                Howler.masterGain.connect(Howler.ctx.destination);
            }

            function setupAnalyzer() {
                if (Howler.analyser) return;

                // Create an analyser node in the Howler WebAudio context
                var analyser = Howler.ctx.createAnalyser();

                Howler.analyser = analyser;
                Howler.connectAnalyzer = connectAnalyzer;
                Howler.disconnectAnalyzer = disconnectAnalyzer;

                Howler.analyser.connect(Howler.ctx.destination);
            }

            HowlerGlobal.prototype._setup = (function(_super) {
                return function(o) {
                  var self = this || Howler;


                  if (supportSideChain()) {
                    if (useCompressor()) {
                        self.compressor = self.ctx.createDynamicsCompressor();
                        self.makeUpGain = (typeof self.ctx.createGain === 'undefined') ? self.ctx.createGainNode() : self.ctx.createGain();

                        self.updateCompressorMakeUpGain = updateCompressorMakeUpGain;

                        updateCompressorMakeUpGain(0);

                        self.compressor.connect(self.makeUpGain);
                        self.makeUpGain.connect(self.masterGain);
                    } else {
                        self.sidechainSettings = {
                            gain: 0.4,
                            attack: 0.25, // in seconds
                            release: 3 // in seconds
                        }
                    }

                    self.normalGain = (typeof self.ctx.createGain === 'undefined') ? self.ctx.createGainNode() : self.ctx.createGain();
                    self.sidechainGain = (typeof self.ctx.createGain === 'undefined') ? self.ctx.createGainNode() : self.ctx.createGain();

                    self.sidechainGain.connect(self.masterGain);
                    self.normalGain.connect(self.masterGain);

                    self.connectCompressor = connectCompressor;
                    self.disconnectCompressor = disconnectCompressor;
                    self.updateCompressorSettings = updateCompressorSettings;
                  }

                  if (CC_DEBUG) {
                    setupAnalyzer();
                  }


                  return _super.call(self, o);
                }
              })(HowlerGlobal.prototype._setup);

            /* eslint-disable */
            /**
                * Setup the audio context when available, or switch to HTML5 Audio mode.
                */
            var setupAudioContext = function () {
                // If we have already detected that Web Audio isn't supported, don't run this step again.
                if (!Howler.usingWebAudio) {
                    return;
                }

                // Check if we are using Web Audio and setup the AudioContext if we are.
                try {
                    if (typeof AudioContext !== 'undefined') {
                        Howler.ctx = new AudioContext();
                    } else if (typeof webkitAudioContext !== 'undefined') {
                        Howler.ctx = new webkitAudioContext();
                    } else {
                        Howler.usingWebAudio = false;
                    }
                } catch (e) {
                    Howler.usingWebAudio = false;
                }

                // If the audio context creation still failed, set using web audio to false.
                if (!Howler.ctx) {
                    Howler.usingWebAudio = false;
                }

                // Check if a webview is being used on iOS8 or earlier (rather than the browser).
                // If it is, disable Web Audio as it causes crashing.
                var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
                var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                var version = appVersion ? parseInt(appVersion[1], 10) : null;
                if (iOS && version && version < 9) {
                    var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
                    if (Howler._navigator && !safari) {
                        Howler.usingWebAudio = false;
                    }
                }

                // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
                if (Howler.usingWebAudio) {
                    Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
                    Howler.masterGain.gain.setValueAtTime(Howler._muted ? 0 : Howler._volume, Howler.ctx.currentTime);
                    Howler.masterGain.connect(Howler.ctx.destination);
                }

                // Re-run the setup on Howler.
                Howler._setup();
            };

            Sound.prototype.create = (function(_super) {
                return function() {
                    var self = this;
                    var parent = self._parent;
                    const sound =  _super.call(self);

                    if (supportSideChain()) {
                        self._node.disconnect(Howler.masterGain);
                        self._node.connect(Howler.normalGain);
                    }

                    return sound;
                }
            })(Sound.prototype.create);

            /**
             * - added fade start event listener (see fade function for reason)
             * @param {*} o
             */
            Howl.prototype.init = function (o) {
                var self = this;

                // If we don't have an AudioContext created yet, run the setup.
                if (!Howler.ctx) {
                    setupAudioContext();
                }

                // Setup user-defined default properties.
                self._autoplay = o.autoplay || false;
                self._format = (typeof o.format !== 'string') ? o.format : [o.format];
                self._html5 = o.html5 || false;
                self._muted = o.mute || false;
                self._loop = o.loop || false;
                self._pool = o.pool || 5;
                self._preload = (typeof o.preload === 'boolean' || o.preload === 'metadata') ? o.preload : true;
                self._rate = o.rate || 1;
                self._sprite = o.sprite || {};
                self._src = (typeof o.src !== 'string') ? o.src : [o.src];
                self._volume = o.volume !== undefined ? o.volume : 1;
                self._xhr = {
                    method: o.xhr && o.xhr.method ? o.xhr.method : 'GET',
                    headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                    withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false,
                };

                // Setup all other default properties.
                self._duration = 0;
                self._state = 'unloaded';
                self._sounds = [];
                self._endTimers = {};
                self._queue = [];
                self._playLock = false;

                // Setup event listeners.
                self._onend = o.onend ? [{ fn: o.onend }] : [];
                self._onfade = o.onfade ? [{ fn: o.onfade }] : [];
                self._onfadestart = o.onfadestart ? [{ fn: o.onfadestart }] : [];
                self._onload = o.onload ? [{ fn: o.onload }] : [];
                self._onloaderror = o.onloaderror ? [{ fn: o.onloaderror }] : [];
                self._onplayerror = o.onplayerror ? [{ fn: o.onplayerror }] : [];
                self._onpause = o.onpause ? [{ fn: o.onpause }] : [];
                self._onplay = o.onplay ? [{ fn: o.onplay }] : [];
                self._onstop = o.onstop ? [{ fn: o.onstop }] : [];
                self._onmute = o.onmute ? [{ fn: o.onmute }] : [];
                self._onvolume = o.onvolume ? [{ fn: o.onvolume }] : [];
                self._onrate = o.onrate ? [{ fn: o.onrate }] : [];
                self._onseek = o.onseek ? [{ fn: o.onseek }] : [];
                self._onunlock = o.onunlock ? [{ fn: o.onunlock }] : [];
                self._onresume = [];

                // Web Audio or HTML5 Audio?
                self._webAudio = Howler.usingWebAudio && !self._html5;

                // Automatically try to enable audio.
                if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.autoUnlock) {
                    Howler._unlockAudio();
                }

                // Keep track of this Howl group in the global controller.
                Howler._howls.push(self);

                // If they selected autoplay, add a play event to the load queue.
                if (self._autoplay) {
                    self._queue.push({
                        event: 'play',
                        action: function () {
                            self.play();
                        }
                    });
                }

                // Load the source file unless otherwise specified.
                if (self._preload && self._preload !== 'none') {
                    self.load();
                }

                return self;
            };

            /**
             * changed load queue event to 'fadestart', this is so to prevent multiple calls to fade function when audioContext is suspended/locked
             */
            Howl.prototype.fade = function (from, to, len, id) {
                var self = this;

                // If the sound hasn't loaded, add it to the load queue to fade when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        // define event of the start of fade
                        event: 'fadestart',
                        action: function () {
                            //   console.warn(`[howler] fade load queue ${id}`);
                            if (self._fadeTo !== null) {
                                self.fade(from, to, len, id);
                            }
                        }
                    });

                    return self;
                }

                // console.warn(`[howler] fade ${id}`);

                // Make sure the to/from/len values are numbers.
                from = Math.min(Math.max(0, parseFloat(from)), 1);
                to = Math.min(Math.max(0, parseFloat(to)), 1);
                len = parseFloat(len);

                // Set the volume to the start position.
                self.volume(from, id);

                // Fade the volume of one or all sounds.
                var ids = self._getSoundIds(id);
                for (var i = 0; i < ids.length; i++) {
                    // Get the sound.
                    var sound = self._soundById(ids[i]);

                    // Create a linear fade or fall back to timeouts with HTML5 Audio.
                    if (sound) {
                        // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                        if (!id) {
                            self._stopFade(ids[i]);
                        }

                        // If we are using Web Audio, let the native methods do the actual fade.
                        if (self._webAudio && !sound._muted) {
                            var currentTime = Howler.ctx.currentTime;
                            var end = currentTime + (len / 1000);
                            sound._volume = from;
                            sound._node.gain.setValueAtTime(from, currentTime);
                            sound._node.gain.linearRampToValueAtTime(to, end);
                        }

                        self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
                    }
                }

                // fade has already started, this is so to remove it from the loadqueue if present and void calling it again
                self._emit('fadestart', id)

                return self;
            },

            /**
             * added some additional parameters for sound playback
             * @param {*} sprite
             * @param {*} internal
             * @param {*} forceVolume
             * @param {*} forceLoop
             * @param {*} forceMute
             */
            Howl.prototype.play = function (sprite, internal, forceVolume, forceLoop, forceMute, forceSidechain) {
                const self = this;
                let id = null;

                // Determine if a sprite, sound id or nothing was passed
                if (typeof sprite === 'number') {
                    id = sprite;
                    sprite = null;
                } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
                    // If the passed sprite doesn't exist, do nothing.
                    return null;
                } else if (typeof sprite === 'undefined') {
                    // Use the default sound sprite (plays the full audio length).
                    sprite = '__default';

                    // Check if there is a single paused sound that isn't ended.
                    // If there is, play that sound. If not, continue as usual.
                    if (!self._playLock) {
                        let num = 0;

                        for (let i = 0; i < self._sounds.length; i++) {
                            if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                                num++;
                                id = self._sounds[i]._id;
                            }
                        }

                        if (num === 1) {
                            sprite = null;
                        } else {
                            id = null;
                        }
                    }
                }

                // Get the selected node, or get one from the pool.
                const sound = id ? self._soundById(id) : self._inactiveSound();

                // If the sound doesn't exist, do nothing.
                if (!sound) {
                    return null;
                }

                // handle resumed sounds??
                // Select the sprite definition.
                if (id && !sprite) {
                    sprite = sound._sprite || '__default';
                    forceSidechain = !!sound._sidechain;
                }

                // If the sound hasn't loaded, we must wait to get the audio's duration.
                // We also need to wait to make sure we don't run into race conditions with
                // the order of function calls.
                if (self._state !== 'loaded') {
                    // Set the sprite value on this sound.
                    sound._sprite = sprite;

                    // Mark this sound as not ended in case another sound is played before this one loads.
                    sound._ended = false;

                    // Add the sound to the queue to be played on load.
                    const soundId = sound._id;

                    self._queue.push({
                        event: 'play',
                        action() {
                            self.play(soundId, false, forceVolume, forceLoop, forceMute);
                        }
                    });

                    return soundId;
                }

                // Don't play the sound if an id was passed and it is already playing.
                if (id && !sound._paused) {
                    // Trigger the play event, in order to keep iterating through queue.
                    if (!internal) {
                        self._loadQueue('play');
                    }

                    return sound._id;
                }

                // Make sure the AudioContext isn't suspended, and resume it if it is.
                if (self._webAudio) {
                    Howler._autoResume();
                }

                // Determine how long to play for and where to start playing.
                const seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
                const duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
                const timeout = (duration * 1000) / Math.abs(sound._rate);
                const start = self._sprite[sprite][0] / 1000;
                const stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
                const loop = !!(sound._loop || self._sprite[sprite][2]) || forceLoop;
                const muted = !!forceMute;
                const sidechain = forceSidechain || false;

                sound._sprite = sprite;

                if (typeof forceVolume !== 'undefined') {
                    sound._volume = forceVolume;
                }

                // Mark the sound as ended instantly so that this async playback
                // doesn't get grabbed by another call to play while this one waits to start.
                sound._ended = false;

                // Update the parameters of the sound.
                const setParams = function () {
                    sound._paused = false;
                    sound._seek = seek;
                    sound._start = start;
                    sound._stop = stop;
                    sound._loop = loop;
                    sound._muted = muted;
                    sound._sidechain = sidechain;
                };

                // End the sound instantly if seek is at the end.
                if (seek >= stop) {
                    self._ended(sound);

                    return;
                }

                // Begin the actual playback.
                const node = sound._node;

                if (supportSideChain()) {
                    node.disconnect();
                    if (sidechain) {
                        connectCompressor();
                        node.connect(Howler.sidechainGain);
                    } else {
                        node.connect(Howler.normalGain)
                    }
                }

                if (self._webAudio) {
                    // Fire this when the sound is ready to play to begin Web Audio playback.
                    const playWebAudio = function () {
                        self._playLock = false;
                        setParams();
                        self._refreshBuffer(sound);

                        // Setup the playback params.
                        let vol = (sound._muted || self._muted) ? 0 : sound._volume;

                        node.gain.cancelScheduledValues(Howler.ctx.currentTime);
                        node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
                        sound._playStart = Howler.ctx.currentTime;

                        // Play the sound using the supported method.
                        if (typeof node.bufferSource.start === 'undefined') {
                            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                        } else {
                            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                        }

                        // Start a new timer if none is present.
                        if (timeout !== Infinity) {
                            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        }

                        if (!internal) {
                            setTimeout(() => {
                                self._emit('play', sound._id);
                                self._loadQueue();
                            }, 0);
                        }
                    };

                    if (Howler.state === 'running') {
                        playWebAudio();
                    } else {
                        self._playLock = true;

                        // Wait for the audio context to resume before playing.
                        self.once('resume', playWebAudio);

                        // Cancel the end timer.
                        self._clearTimer(sound._id);
                    }
                } else {
                    // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                    const playHtml5 = function () {
                        node.currentTime = seek;
                        node.muted = sound._muted || self._muted || Howler._muted || node.muted;
                        node.volume = sound._volume * Howler.volume();
                        node.playbackRate = sound._rate;

                        // Some browsers will throw an error if this is called without user interaction.
                        try {
                            const play = node.play();

                            // Support older browsers that don't support promises, and thus don't have this issue.
                            if (play && typeof Promise !== 'undefined' && (play instanceof Promise || typeof play.then === 'function')) {
                                // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                                self._playLock = true;

                                // Set param values immediately.
                                setParams();

                                // Releases the lock and executes queued actions.
                                play.
                                    then(() => {
                                        self._playLock = false;
                                        node._unlocked = true;
                                        if (!internal) {
                                            self._emit('play', sound._id);
                                            self._loadQueue();
                                        }
                                    }).
                                    catch(() => {
                                        self._playLock = false;
                                        self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
                                            'on mobile devices and Chrome where playback was not within a user interaction.');

                                        // Reset the ended and paused values.
                                        sound._ended = true;
                                        sound._paused = true;
                                    });
                            } else if (!internal) {
                                self._playLock = false;
                                setParams();
                                self._emit('play', sound._id);
                                self._loadQueue();
                            }

                            // Setting rate before playing won't work in IE, so we set it again here.
                            node.playbackRate = sound._rate;

                            // If the node is still paused, then we can assume there was a playback issue.
                            if (node.paused) {
                                self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
                                    'on mobile devices and Chrome where playback was not within a user interaction.');

                                return;
                            }

                            // Setup the end timer on sprites or listen for the ended event.
                            if (sprite !== '__default' || sound._loop) {
                                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                            } else {
                                self._endTimers[sound._id] = function () {
                                    // Fire ended on this audio node.
                                    self._ended(sound);

                                    // Clear this listener.
                                    node.removeEventListener('ended', self._endTimers[sound._id], false);
                                };
                                node.addEventListener('ended', self._endTimers[sound._id], false);
                            }
                        } catch (err) {
                            self._emit('playerror', sound._id, err);
                        }
                    };

                    // If this is streaming audio, make sure the src is set and load again.
                    if (node.src === 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA') {
                        node.src = self._src;
                        node.load();
                    }

                    // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                    const loadedNoReadyState = (window && window.ejecta) || (!node.readyState && Howler._navigator.isCocoonJS);

                    if (node.readyState >= 3 || loadedNoReadyState) {
                        playHtml5();
                    } else {
                        self._playLock = true;

                        var listener = function () {
                            // Begin playback.
                            playHtml5();

                            // Clear this listener.
                            node.removeEventListener(Howler._canPlayEvent, listener, false);
                        };

                        node.addEventListener(Howler._canPlayEvent, listener, false);

                        // Cancel the end timer.
                        self._clearTimer(sound._id);
                    }
                }

                return sound._id;
            };

            /**
             * Stop playback and reset to start.
             * @param  {Number} id The sound ID (empty to stop all in group).
             * @param  {Boolean} internal Internal Use: true prevents event firing.
             * @return {Howl}
             */
            Howl.prototype.stop = function (id, internal) {
                var self = this;

                // If the sound hasn't loaded, add it to the load queue to stop when capable.
                if (self._state !== 'loaded' || self._playLock) {
                  self._queue.push({
                    event: 'stop',
                    action: function() {
                      self.stop(id);
                    }
                  });

                  return self;
                }

                // If no id is passed, get all ID's to be stopped.
                var ids = self._getSoundIds(id);

                for (var i=0; i<ids.length; i++) {
                  // Clear the end timer.
                  self._clearTimer(ids[i]);

                  // Get the sound.
                  var sound = self._soundById(ids[i]);

                  if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;

                    // Stop currently running fades.
                    self._stopFade(ids[i]);

                    if (sound._sidechain) {
                        sound._sidechain = false;
                        disconnectCompressor();
                    }

                    if (sound._node) {
                      if (self._webAudio) {
                        // Make sure the sound's AudioBufferSourceNode has been created.
                        if (sound._node.bufferSource) {
                          if (typeof sound._node.bufferSource.stop === 'undefined') {
                            sound._node.bufferSource.noteOff(0);
                          } else {
                            sound._node.bufferSource.stop(0);
                          }

                          // Clean up the buffer source.
                          self._cleanBuffer(sound._node);
                        }
                      } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                        sound._node.currentTime = sound._start || 0;
                        sound._node.pause();

                        // If this is a live stream, stop download once the audio is stopped.
                        if (sound._node.duration === Infinity) {
                          self._clearSound(sound._node);
                        }
                      }
                    }

                    if (!internal) {
                      self._emit('stop', sound._id);
                    }
                  }
                }

                return self;
            };

            Howl.prototype._ended = function (sound) {
                var self = this;
                var sprite = sound._sprite;

                // If we are using IE and there was network latency we may be clipping
                // audio before it completes playing. Lets check the node to make sure it
                // believes it has completed, before ending the playback.
                if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                  setTimeout(self._ended.bind(self, sound), 100);
                  return self;
                }

                // Should this sound loop?
                var loop = !!(sound._loop || self._sprite[sprite][2]);

                // Fire the ended event.
                self._emit('end', sound._id);

                if (!loop && sound._sidechain) {
                    sound._sidechain = false;
                    disconnectCompressor();
                }

                // Restart the playback for HTML5 Audio loop.
                if (!self._webAudio && loop) {
                  self.stop(sound._id, true).play(sound._id);
                }

                // Restart this timer if on a Web Audio loop.
                if (self._webAudio && loop) {
                  self._emit('play', sound._id);
                  sound._seek = sound._start || 0;
                  sound._rateSeek = 0;
                  sound._playStart = Howler.ctx.currentTime;

                  var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
                  self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                }

                // Mark the node as paused.
                if (self._webAudio && !loop) {
                  sound._paused = true;
                  sound._ended = true;
                  sound._seek = sound._start || 0;
                  sound._rateSeek = 0;
                  self._clearTimer(sound._id);

                  // Clean up the buffer source.
                  self._cleanBuffer(sound._node);

                  // Attempt to auto-suspend AudioContext if no sounds are still playing.
                  Howler._autoSuspend();
                }

                // When using a sprite, end the track.
                if (!self._webAudio && !loop) {
                  self.stop(sound._id, true);
                }

                return self;
            }
            /* eslint-enable */
        }
    },

    ctor() {
        this._audioSprites = new Map();
        // DynamicsCompressorNode default values
        // https://developer.mozilla.org/en-US/docs/Web/API/DynamicsCompressorNode
        this.compressorSettings = {
            threshold: -24,
            knee: 30,
            ratio: 12,
            attack: 0.003,
            release: 0.25,
            gain: 0.4,
            makeup: 0,
            autoMakeup: false
        };
    },

    onLoad() {
        this._super();
        /**
         * for keeping track of howler instances. for now each audioclip has its own instances
         */
        this.soundMap = new Map();
        this.updateSideChainSettings();
    },

    /**
     *
     * @param {*} settings example:
     * {
            gain: 0.4,
            attack: 0.003,
            release: 0.25,
     * }
     * @returns
     */
    updateSideChainSettings(settings) {
        if (!Howler.updateCompressorSettings) return;

        this.compressorSettings = Object.assign(this.compressorSettings, settings);

        Howler.updateCompressorSettings(this.compressorSettings);
    },

    // TODO move it to a utility class
    _ensureNumber(number) {
        if (typeof number === 'number') {
            return number;
        }

        if (typeof number === 'string') {
            number = Number(number);

            return number;
        }

        cc.warn(`unable to parse to number: ${number}`);

        return null;
    },

    //#region specific functions
    /**
     * Get Howler instance by cc.Audio
     * @param {cc.Audio} audioclip
     */
    _getHowlerInstanceByAudioClip(audioclip) {
        const howls = this._getHowls();

        for (let i = 0; i < howls.length; i++) {
            const howl = howls[i];

            // eslint-disable-next-line no-underscore-dangle
            if (howl._src === audioclip.nativeUrl) {
                return howl;
            }
        }

        return null;
    },

    // returns array of howl instances by spritename.
    // its possible that multiple instances to be returned
    _getActiveSoundIDsBySpriteName(spriteName) {
        const howls = this._getHowls();
        const ret = [];

        howls.some((howl) => {
            // eslint-disable-next-line no-underscore-dangle
            return howl._sounds.some((sound) => {
                // eslint-disable-next-line no-underscore-dangle
                if (sound._sprite === spriteName) {
                    // eslint-disable-next-line no-underscore-dangle
                    ret.push(sound._id);
                    // return true;
                }
            });
        });

        return ret;
    },

    _getHowls() {
        // eslint-disable-next-line no-underscore-dangle
        return Howler._howls;
    },

    _getIds(howl) {
        // eslint-disable-next-line no-underscore-dangle
        return Howler._howls.find((val) => {
            return val === howl;
        })._getSoundIds();
    },

    /**
     * Get Howler instance by it's audio ID
     * @param {Number} id
     */
    _getHowlerInstanceByAudioId(id) {
        const howls = this._getHowls();

        for (let i = 0; i < howls.length; i++) {
            const howl = howls[i];

            const ids = this._getIds(howl);

            for (let j = 0; j < ids.length; j++) {
                if (id === ids[j]) {
                    return howl;
                }
            }
        }

        return null;
    },

    /** Get Howler Sound Instance by Id */
    _getSoundInstanceByAudioId(id) {
        const howls = this._getHowls();

        for (let i = 0; i < howls.length; i++) {
            const howl = howls[i];

            const ids = this._getIds(howl);

            for (let j = 0; j < ids.length; j++) {
                if (id === ids[j]) {
                    // eslint-disable-next-line no-underscore-dangle
                    const sound = howl._sounds.filter((v) => v._id === id);

                    if (sound.length > 0) {
                        return sound[0];
                    }
                }
            }
        }

        return null;
    },

    _updateInstanceVolume(howl, newVolume, id = null) {
        newVolume = parseFloat(newVolume);
        if (id === null) {
            howl.volume(newVolume);
        } else {
            howl.volume(newVolume, id);
        }

    },
    //#endregion

    //#region Functions to be overridden
    /**\
     *  Set Volume for a specific sound
     * @param {*} audio
     * @param {*} volume
     */
    _setSoundVolume(audio, volume) {
        if (audio) {
            if (audio instanceof cc.AudioClip) {
                const howl = this._getHowlerInstanceByAudioClip(audio);

                if (howl && howl.volume() !== volume) {
                    this._updateInstanceVolume(howl, volume);
                } else {
                    cc.error(`sound file not found in mappings: ${howl.nativeUrl}`);
                }

            } else {
                const id = this._ensureNumber(audio);
                const howl = this._getHowlerInstanceByAudioId(id);

                // cc.log(`_setSoundVolume sprite: ${id} volume: ${howl.volume(id)} new volume: ${volume}`)

                if (howl && howl.volume() !== volume) {
                    this._updateInstanceVolume(howl, volume, id);
                }
            }
        }
    },

    /**
     * Resume paused sound
     * @param {Number} audioId
     */
    _resumeSound(audioId, volume, loop) {
        const id = this._ensureNumber(audioId);
        const howl = this._getHowlerInstanceByAudioId(id);

        // eslint-disable-next-line no-underscore-dangle
        if (howl !== null && !howl.playing(id)
            // causes double playback when the audiocontext is locked
            && !howl._playLock
            ) {
            howl.play(id, false, volume, loop);
        }
    },

    /**
     * Pause sound
     * @param {Number} audioId
     */
    _pauseSound(audioId) {
        const id = this._ensureNumber(audioId);
        const howl = this._getHowlerInstanceByAudioId(id);

        if (howl !== null) {
            howl.pause(id);
        }
    },

    _ensureSoundInstance(file, json, onload, onloaderror) {
        let howl = this._getHowlerInstanceByAudioClip(file);

        if (!howl) {
            const sprite = json ? json.sprite : null;
            const param = {
                src: [file.nativeUrl],
                preload: true,
                onload: () => {
                    if (onload) {
                        onload(true);
                    }

                },
                onloaderror: (id, msg) => {
                    cc.error(msg);
                    if (onloaderror) {
                        onloaderror(`${id} ${msg}`);
                    }

                }
            };

            if (sprite) {
                param.sprite = sprite;
            }

            howl = new Howl(param);

            return howl;
        }

        return howl;
    },

    /**
     * play audio sound with specified options
     * @param {cc.AudioClip} audioclip audio clip to be played
     * @param {boolean} loop loop audio if true
     * @param {Number} volume volume of the audio to be played
     * @param {function} onAudioEndCallback function to be called when an audio has ended
     * @param {bool} [isOneShot] if true, the played audio will not be added to sfxmaps and no callbacks will be made
     * @returns {Number} unique id of the played audio
     */
    _playSound(audioclip, loop, volume, muted, onAudioEndCallback, isOneShot = false, sidechain = false) {
        if (!audioclip) {
            throw new Error('audioclip null');
        }

        const howl = this._ensureSoundInstance(audioclip);
        const id = howl.play(void 0, false, volume, loop, muted, sidechain);

        if (id === null) {
            cc.warn(`howler returned null id for ${audioclip.name}. Audioclip could be not loaded. If audiosprite, it can be wrong spritename`);

            return;
        }

        if (isOneShot) {
            howl.volume(volume, id);

            return id;
        }

        // if (loop) {
        //     howl.loop(loop, id);

        //     // firefox and safari fix
        //     howl.play(id, false, volume);
        // }

        this._updateInstanceVolume(howl, volume);

        howl.on('end', () => {
            if (!howl.loop(id)) {
                if (CC_AUDIO_DEBUG) {
                    cc.log(`audio play end with id: ${id}`);
                }
            }
            if (CC_AUDIO_DEBUG) {
                cc.log(`audio play end with id: ${id} ${audioclip.toString()}`);
            }

            if (onAudioEndCallback) {
                onAudioEndCallback();
            }
        }, id);

        if (CC_AUDIO_DEBUG) {
            howl.once('load', () => {
                cc.log(`audio loaded: ${id} ${audioclip.toString()}`, id);
            });

            howl.once('stop', () => {
                cc.log(`audio stopped: ${id} ${audioclip.toString()}`, id);
            });
        }

        return id;
    },

    /**
     * Stop sound
     * @param {Number} audioId
     */
    _stopSound(audio) {
        let result = false;
        let howl = null;
        let id = null;

        if (typeof audio === 'number') {
            id = audio;
            howl = this._getHowlerInstanceByAudioId(id);
        } else if (audio instanceof cc.AudioClip) {
            howl = this._getHowlerInstanceByAudioClip(audio);
        }

        if (howl) {
            if (id !== null) {
                howl.stop(id);
            } else {
                howl.stop();
            }

            result = true;
        }

        return result;
    },

    /**
     * Stop all sound playback
     */
    _stopAllSounds() {
        this._getHowls().forEach((howl) => {
            howl.stop();
        });
    },

    _muteSound(audio, isMute = true) {
        if (audio instanceof cc.AudioClip) {
            const howl = this._getHowlerInstanceByAudioClip(audio);

            if (howl) {
                howl.mute(isMute);
            }

        } else if (cc.js.isNumber(audio)) {
            const howl = this._getHowlerInstanceByAudioId(audio);

            if (howl) {
                howl.mute(isMute, audio);
            }
        } else {
            this._getHowls().forEach((howl) => {
                howl.mute(isMute);
            });
        }

    },

    _unmuteSound(audio) {
        this._muteSound(audio, false);
    },

    _fadeSound(from, to, duration, audioId, onFadeCompleteCallback) {
        cc.log('_fadeSound ' + audioId);
        const id = this._ensureNumber(audioId);
        const howl = this._getHowlerInstanceByAudioId(id);

        if (howl) {
            // eslint-disable-next-line no-underscore-dangle
            from = from === null ? howl._volume : from;

            howl.fade(from, to, duration, id);

            if (onFadeCompleteCallback) {
                howl.once('fade', onFadeCompleteCallback, id);
            }

        }
    },

    _setSoundRate(rate, audioId) {
        const id = this._ensureNumber(audioId);
        const howl = this._getHowlerInstanceByAudioId(id);

        if (howl) {
            howl.rate(rate, id);
        }
    },

    _setLoop(isLoop, audioId) {
        const id = this._ensureNumber(audioId);
        const howl = this._getHowlerInstanceByAudioId(audioId);

        if (howl) {
            howl.loop(isLoop, id);
        }
    },

    _isLoop(audioId) {
        const id = this._ensureNumber(audioId);
        const howl = this._getHowlerInstanceByAudioId(id);

        if (howl) {
            return howl.loop(id);
        }

        return false;
    },

    _isPlaying(audio) {
        if (audio instanceof cc.AudioClip) {
            const howl = this._getHowlerInstanceByAudioClip(audio);

            if (howl) {
                return howl.playing();
            }

        } else {
            const id = this._ensureNumber(audio);
            const howl = this._getHowlerInstanceByAudioId(id);

            if (howl) {
                return howl.playing(id);
            }
        }

        return false;
    },

    _isLoaded(audio) {
        const howl = this._getHowlerInstanceByAudioClip(audio);

        if (howl) {
            return howl.state() === 'loaded';
        }

        return false;
    },
    //#endregion

    _preloadAudio(file, json = null) {
        return new Promise((resolve, reject) => {
            const howl = this._ensureSoundInstance(file, json, resolve, reject);

            if (json !== null) {
                // eslint-disable-next-line no-underscore-dangle
                howl._sprite = json.sprite;
            }

            if (howl) {
                resolve(true);
            }
        });

    },

    _playAudioSprite(file, spriteName, loop, volume, muted, onAudioEndCallback, sidechain) {
        const howl = this._ensureSoundInstance(file);

        if (howl === null) {
            return -1;
        }

        const id = howl.play(spriteName, false, volume, loop, muted, sidechain);

        if (id === null) {
            cc.warn(`cannot play audio sprite ${spriteName}`);

            return;
        }

        //howl.volume(volume, id);

        // if (loop) {
        //     howl.loop(loop, id);
        // }

        // todo cleanup listener
        howl.on('end', () => {
            if (!howl.loop(id)) {
                if (CC_AUDIO_DEBUG) {
                    cc.log(`audio play end with id: ${id} ${spriteName} `);
                }

                if (id !== null) {
                    howl.off('end', id);
                } else {
                    cc.error('id is null');
                }

            } else {
                if (CC_AUDIO_DEBUG) {
                    cc.log(`audio loop end with id: ${id} ${spriteName} `);
                }
            }

            if (onAudioEndCallback) {
                onAudioEndCallback();
            }

        }, id);

        return id;
    },

    _getVolume(audio) {
        if (audio instanceof cc.AudioClip) {
            const howl = this._getHowlerInstanceByAudioClip(audio);

            if (howl) {
                return howl.volume();
            }
        } else {
            const id = this._ensureNumber(audio);

            if (id !== null) {
                const howl = this._getSoundInstanceByAudioId(id);

                //cc.log(`howl volume of ${  audio  } is ${  howl._volume}`);

                // eslint-disable-next-line no-underscore-dangle
                return howl !== null ? howl._volume : null;
            }

        }

        return null;
    }

});
